import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/src/app/producto-nuevo/[productSlug]/ProductDetailsClient.tsx");
